import style from "./style.module.css";
import video from "../../../assets/video.svg";
import search from "../../../assets/search.svg";
import reload from "../../../assets/reload.svg";
import plus from "../../../assets/plus.svg";
import excel from "../../../assets/modalIcons/excel.svg";
import pdf from "../../../assets/pdf.svg";
import { Link } from "react-router-dom";
import { useContext } from "react";
import StoreContext from "../../../context/store";
import { getAttendancePdf } from "../../../api/general";

const Bar = () => {
  const {
    setAddAttendanceClick,
    setAttendanceInputValue,
    attendanceInputValue,
  } = useContext(StoreContext);

  const getAttendancePdfMethod = async () => {
    const response = await getAttendancePdf();
    if (response.error) {
      console.log("Yoklama pdfi gelmedi");
      console.log(response.error, "response.erro");
    } else {
      console.log("Yoklama pdfi geldi");
    }
  };



  return (
    <div className={style.container}>
      <div className={style.attendances}>
        <div className={style.attendancestext}>Yoklamalar</div>
        <Link>
          <img alt="" className={style.attendancesvideo} src={video}></img>
        </Link>
      </div>
      <div className={style.search}>
        <button className={style.searchicon}>
          <img alt="" src={search}></img>
        </button>
        <input
          className={style.searchinput}
          placeholder="Ara"
          onChange={(e) => {
            setAttendanceInputValue(e.target.value);
          }}
          value={attendanceInputValue}
        ></input>
      </div>
      <button
        onClick={() => {
          window.location.reload();
        }}
      >

        <img alt="" className={style.reload} src={reload}></img>
      </button>
      <div className={style.tabs}>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
                 setAddAttendanceClick(true);
            }}
          >
            <img alt="" src={plus}></img>
          </button>
          <div className={style.tabtext}>Yeni Yoklama</div>
        </div>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
           //   getExamPdfMethod();
            }}
          >
            <img alt="" src={excel}></img>
          </button>
          <div className={style.tabtext}>Excel Aktar</div>
      </div>
      </div>
    </div>
  );
};

export default Bar;
